export default "__VITE_PUBLIC_ASSET__865a75fa__"